import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import styles from './Onboarding.module.css';
import {
  computeRisk, getWorkflow, languageForApi, getUserProfile, raiseGAEvent
  // , getCaseForUser, createUserCase, postEvent
} from '../../utils/network';
import { responseForPosting, deleteQuestionIdsFromSessionStorage } from './utils';
import { ess } from './ess';
import Loader from '../Loader';
import { fireSurveyResultEvent } from '../../utils/events';
import { parseQueryString, isDesktopScreen, logError, appStorage } from '../../utils/utils';
import UserResponses from './UserResponses';
import useTranslation from '../../hooks/use-translation';
import getSource from '../../utils/get-source';
import Error from '../Commons/error';
import { putInStorage } from '../../utils/get-location/location-from-storage';
import config from '../../config.json';
import { gaTid } from '../../config.json';

const getUserId = async () => {
  const { uid } = parseQueryString();
  if (uid) {
    return Promise.resolve(uid);
  }
  const sourceData = await getSource();
  return sourceData.source_user_id;
};

const getSourceId = async () => {
  const { source_id } = parseQueryString();
  if (source_id) {
    return Promise.resolve(source_id);
  }
  const sourceData = await getSource();
  return sourceData.source_id;
}


const getSeverityFromResults = results => {
  if (!results) return '';
  const { meta_data = {} } = results;
  const { display_data = {} } = meta_data;
  const { risk_advisory = {} } = display_data;
  const { severity = '' } = risk_advisory;
  return severity;
};

export default () => {
  const [state, setState] = useState({
    displayLoader: true,
    results: {},
    userCases: {},
    source_id: undefined
  });
  const [data, setUserData] = useState();
  const {
    t, language, canOptForSurakshaKavach, canShowProfile, shouldMandateProfile
  } = useTranslation();
  const history = useHistory();

  const getComputedRisk = async (language, stateString) => {
    setState(prevState => ({
      ...prevState,
      displayLoader: true
    }));
    // Check in storage for response
    let computeRiskStoredResponse;
    computeRiskStoredResponse = await JSON.parse(getComputeRiskResponse(computeRiskStoredResponse));
    let results;
    let workflowResponse;
    try {
      if (!computeRiskStoredResponse) {
        const response = await getWorkflow(language);
        const { worflow_template: questions, workflow_id } = response;
        const userId = await getUserId();
        const userInput = responseForPosting(questions);
        if (userInput === undefined || userInput.length === 0) {
          history.replace('/');
          return;
        }
        workflowResponse = {
          source_user_id: userId,
          workflow_id,
          language: languageForApi(language),
          workflow_responses: responseForPosting(questions)
        };

        results = await computeRisk(workflowResponse);
        //delete questionId-answerID key-value pairs from appStorage
        deleteQuestionIdsFromSessionStorage(questions);
        // Store response in Storage
        setComputeRiskResponse(results);
      } else {
        results = computeRiskStoredResponse;
      }

      if (results.apiResponseCode === 'success') {
        let isEventSuccess = appStorage.getItem("fireSurveyResultEvent");

        if (!isEventSuccess) {
          var eventResponse = await fireSurveyResultEvent(language, results, workflowResponse, ess().eventData);
          getSourceId()
            .then(sourceId => {
              raiseGAEvent(config.gaEcSymptomChecker, config.gaEaCompleted, sourceId);
              appStorage.removeItem("gaEventScInit");
            })
          if (eventResponse.statusCode === 200) {
            appStorage.setItem("fireSurveyResultEvent", true);
          }
        }
        setState(prevState => ({
          ...prevState,
          results,
          displayLoader: false,
          error: false
        }));
      } else {
        setState(prevState => ({
          ...prevState,
          displayLoader: false,
          error: true
        }));
      }
    } catch (e) {
      logError(e);
      setState(prevState => ({
        ...prevState,
        displayLoader: false,
        error: true,
        results: {}
      }));
    }
  };


  const getUserData = async () => {
    const data = await getUserProfile();
    const { address = {} } = data;
    putInStorage(address);
    setUserData(data);
  };

  const loadResults = async () => {
    const sourceData = await getSource();
    await getComputedRisk(language, parseQueryString().s);
    sourceData.source_id === 'MyJioApp' && await getUserData();
  };

  useEffect(() => {
    (async () => {
      loadResults();
      // getCases();
    })();
  }, [language]);
  useEffect(() => {
    getSourceId()
      .then(source_id => {
        setState(prevState => ({
          ...prevState,
          source_id
        }));
      })
    return () => {
      if (history.action === "POP") {
        history.replace('/');
        // Code here will run when back button fires. Note that it's after the `return` for useEffect's callback; code before the return will fire after the page mounts, code after when it is about to unmount.
      }
    };
  }, []);


  const severity = getSeverityFromResults(state.results);
  const styleClassForHeader = (state.source_id && (state.source_id === 'JioHealthHub' || state.source_id === 'MyJio' || state.source_id === "JhhWebApp")) ? styles.paddingTopSmall : '';
  const renderDesktopResult = () => (
    <div>
      <div className={styles.desktopSummary}>
        <div className={`${styles.leftSummaryRender} ${styleClassForHeader}`}>
          <div className={styles.title}>{t('SYMPTOM_CHECKER_TITLE')}</div>
          <div
            className={`${styles.risk_card} ${styles[severity]}`}
            style={{ color: 'black' }}
          >
            {t('RISK_TITLE')}
            <br />
            <span className={styles[severity]}>
              {state.results.meta_data.analytics_data.risk_display_category}
            </span>
          </div>
          <div className={styles.risk_sub_title}>
            {t('RISK_ADVISORY_DISCLAIMER')}
          </div>
          <button
            className="doneButtonDesktop"
            onClick={() => navigateToHome(history)}
          >
            {t('CLICK_HERE_TO_COMPLETE')}
          </button>
        </div>
        <div className={`${styles.rightSummaryRender} ${styleClassForHeader}`}>
          <div className={styles.risk_recommendation_title}>
            {t('RECOMMENDATION')}
          </div>
          <div className={styles.risk_recommendation_message}>
            {state.results.meta_data.analytics_data.advisory[0]}
          </div>
          {/* <TeleConsultationBanner />
          <ResultButtons /> */}
          <UserResponses results={state.results} />
        </div>
      </div>
    </div>
  );

  const navigateToHome = async (history) => {
    await appStorage.resetSurveyData();
    const source_id = await getSourceId();
    ess().isFromEss || source_id === 'JioHealthHub' ? window.close() : history.push('/');
  };


  const renderMobileResult = () => (
    <div className={`${styles.container} ${styleClassForHeader}`}>
      <div style={{ width: '100%' }}>
        <div className={styles.title}>{t('SYMPTOM_CHECKER_TITLE')}</div>
        <div
          className={`${styles.risk_card} ${styles[severity]}`}
          style={{ color: 'black' }}
        >
          {t('RISK_TITLE')}
          <br />
          <span className={styles[severity]}>
            {state.results.meta_data.analytics_data.risk_display_category}
          </span>
        </div>
        <div className={styles.risk_sub_title}>
          {t('RISK_ADVISORY_DISCLAIMER')}
        </div>
        <div className={styles.risk_recommendation_title}>
          {t('RECOMMENDATION')}
        </div>
        <div className={styles.risk_recommendation_message}>
          {state.results.meta_data.analytics_data.advisory[0]}
        </div>
        {/* <TeleConsultationBanner />
        <ResultButtons /> */}
        <UserResponses results={state.results} />
        <div className="buttonDiv">
          <button
            className="doneButton"
            onClick={() => navigateToHome(history)}
          >
            Done
          </button>
        </div>
      </div>
    </div>
  );
  useEffect(() => {
    function gtag() { window.dataLayer.push(arguments); }
    gtag('event', 'page_view', {
      page_title: 'Symptom Checker',
      page_location: '/results',
      page_path: window.location.pathname,
      page_referrer: 'https://healthhub.jio.com'
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (state.displayLoader) return <Loader loadingCount={1} />;
  if (state.error) return <Error handleRetry={() => loadResults()} />;
  return isDesktopScreen() ? renderDesktopResult() : renderMobileResult();
};

function getComputeRiskResponse(computeRiskStoredResponse) {
  computeRiskStoredResponse = appStorage.getItem('getComputedRisk');
  return computeRiskStoredResponse;
}

function setComputeRiskResponse(results) {
  appStorage.setItem("getComputedRisk", JSON.stringify(results));
}

